// GENERATED FILE — do not edit, do not commit (see .gitignore).
// Written by frontend/scripts/generate-version.js on install and on every build.
export const buildInfo = {
  commit: '8df0f37',
  branch: 'staging',
  buildDate: '2026-11-05T08:02:04.466Z',
  dirty: true,
} as const;
